import { Route, Routes , Navigate} from "react-router-dom";
import HotelAnalytics from "../../screens/vendors/HotelAnalytics";
import HotelBookings from "../../screens/vendors/HotelBookings";
import HotelDashboardscreen from "../../screens/vendors/HotelDashboardscreen";
import HotelEarning from "../../screens/vendors/HotelEarning";
import HotelNotifications from "../../screens/vendors/HotelNotifications";
import HotelRooms from "../../screens/vendors/HotelRooms";
import HotelRegistration from "../../screens/vendors/auth/HotelRegistration";
import HotelNotificationSetting from "../../screens/vendors/HotelNotificationSetting";
import HotelProfileSetting from "../../screens/vendors/HotelProfileSetting";
import HotelReviews from "../../screens/vendors/HotelReviews";
import BookingDetail from "../../components/vendors/BookingDetail";
import VndSupportTickets from "../../screens/vendors/auth/VndSupportTickets";
import ScrollToTop from "../../components/general/ScrollToTop";


const HotelRoutes = () => {
  return (
    <>
      <ScrollToTop />   

      <Routes>
        <Route index element={<Navigate to="hotel-dashboard" replace />} />
        <Route path="/hotel-dashboard" element={<HotelDashboardscreen />} />
        <Route path="/hotel-rooms" element={<HotelRooms />} />
        <Route path="/hotel-bookings" element={<HotelBookings />} />
        <Route path="/hotel-bookings/detail/:id" element={<BookingDetail />} />

        <Route path="/hotel-notification" element={<HotelNotifications />} />
        <Route path="/hotel-earnings" element={<HotelEarning />} />
        <Route path="/hotel-analytics" element={<HotelAnalytics />} />

        <Route path="/hotel-help-support" element={<VndSupportTickets />} />

        <Route path="/hotel-reviews" element={<HotelReviews />} />
        <Route path="/settings/hotel-settings" element={<HotelRegistration />} />
        <Route path="/settings/hotel-profile-settings" element={<HotelProfileSetting />} />
        <Route path="/settings/notification-settings" element={<HotelNotificationSetting />} />

      </Routes> 
    </>
  );
};

export default HotelRoutes;